// Client-side mirror of backend safetyVerify (reviews.freshness.ts).
// Used for real-time typing feedback in ReviewResponseModal.
// Keep the regexes in sync with the backend — enforcement stays server-side.

const PROCEDURE_RE =
  /\b(root\s+canal|crown|filling|implant|extraction|microsurgery|retreatment|cone\s+beam|cbct|x-?ray|whitening|exam|cavity|surgery|biopsy|sedation|scaling|veneer|cleaning|treatment|procedure|diagnos\w*)\b/i;

const CONFIRMS_VISIT_RE =
  /\b(your\s+(visit|appointment|procedure|treatment)|seeing\s+you|when\s+you\s+came\s+in|as\s+our\s+patient)\b/i;

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function safetyVerify(
  draft: string,
  reviewerName: string | null,
): { passed: boolean; flags: string[] } {
  const flags: string[] = [];

  if (reviewerName) {
    const firstToken = reviewerName.trim().split(/\s+/)[0];
    if (firstToken && firstToken.length > 2) {
      if (new RegExp(`\\b${escapeRegex(firstToken)}\\b`, 'i').test(draft)) {
        flags.push('names_reviewer');
      }
    }
  }

  if (PROCEDURE_RE.test(draft)) flags.push('mentions_procedure');
  if (CONFIRMS_VISIT_RE.test(draft)) flags.push('confirms_visit');

  return { passed: flags.length === 0, flags };
}
